<template>
  <div class="home">
    <a-row :gutter="16">
      <a-col :span="24">
        <a-card title="Informacje RODO">
          <p>
            Zgodnie z art. 13 Ogólnego Rozporządzenia o Ochronie Danych
            Osobowych 2016/679 (RODO) z dnia 27 kwietnia 2016 r. pragniemy
            poinformować iż:
          </p>

          <ol>
            <li>
              Administratorem Pani/Pana danych osobowych jest Politechnika
              Świętokrzyska z siedzibą w Kielcach Al. Tysiąclecia Państwa
              Polskiego 7
            </li>
            <li>
              Kontakt z Inspektorem Ochrony Danych w Politechnice
              Świętokrzyskiej możliwy jest pod numerem tel. nr. 41 34 24 367 lub
              adresem email
              <a href="mailto:j.baranowski@tu.kielce.pl"
              >j.baranowski@tu.kielce.pl</a
              >
            </li>
            <li>
              Pani/Pana dane osobowe przetwarzane będą w celu rejestracji konta
              studenckiego, przyznania dostępu do sieci przewodowej na terenie
              osiedla akademickiego Politechniki Świętokrzyskiej na podstawie
              Art. 6 ust. 1 lit. c – Ogólnego Rozporządzenia o Ochronie Danych
              Osobowych 2016/679 (RODO) z dnia 27 kwietnia 2016 r.
            </li>
            <li>
              Pana/Pani dane osobowe nie będą przekazywane do innych podmiotów
            </li>
            <li>
              Pana/Pani dane osobowe przechowywane będą przez okres korzystania
              z sieci przewodowej na terenie osiedla akademickiego Politechniki
              Świętokrzyskiej a nie dłużej niż przez okres 6 lat. Po tym okresie
              dokonywana dane są usuwane a dokumentacja niszczona.
            </li>
            <li>
              Posiada Pani/Pan prawo do: żądania od administratora dostępu do
              danych osobowych, prawo do ich sprostowania, usunięcia lub
              ograniczenia przetwarzania, prawo do wniesienia sprzeciwu wobec
              przetwarzania, a także prawo do przenoszenia danych
            </li>
            <li>
              Ma Pan/Pani prawo wniesienia skargi do Urzędu Ochrony Danych
              Osobowych, gdy uzasadnione jest, że Pana/Pani dane osobowe
              przetwarzane są przez administratora niezgodnie z Ogólnym
              Rozporządzeniem o Ochronie Danych Osobowych 2016/679 (RODO) z dnia
              27 kwietnia 2016 r.
            </li>
            <li>
              Podanie danych osobowych jest dobrowolne, jednakże niepodanie
              danych w zakresie wymaganym będzie skutkować odmową utworzenia
              konta użytkownika sieci przewodowej dla mieszkańców osiedla
              akademickiego Politechniki Świętokrzyskiej.
            </li>
          </ol>

          <p>
            <strong>Jaki rodzaj Twoich danych osobowych przetwarzamy?</strong>
          </p>

          <ul>
            <li>
              Administracja serwerów osiedla akademickiego Politechniki
              Świętokrzyskiej przetwarza dane wskazane w formularzu rejestracji,
              tj.: imiona, nazwisko, numer PESEL, w&nbsp;przypadku cudzoziemca
              nr paszportu lub karty pobytu, adres MAC urządzeń podłączanych do
              sieci akademickiej, adres zameldowania, nr albumu, nazwę uczelni,
              nazwę kierunku studiów, aktualny semestr nauki, pokój wynajmowany
              na osiedlu akademickim i adres e-mail konta oraz informacje o
              chęci korzystania z sieci przewodowej oraz zgodzie na
              przetwarzanie danych osobowych.
            </li>
          </ul>

          <p>
            <strong
            >Ponadto, w związku z wymogami ustawy prawo telekomunikacyjne
              przetwarzamy również Państwa tzw. „dane retencyjne”, takie
              jak:</strong
            >
          </p>

          <ul>
            <li>
              dane transmisyjne, które oznaczają dane przetwarzane dla celów
              przekazywania komunikatów w sieciach telekomunikacyjnych
              w&nbsp;tym dane lokalizacyjne, które oznaczają wszelkie dane
              przetwarzane w sieci telekomunikacyjnej lub w ramach usług
              telekomunikacyjnych wskazujące położenie geograficzne urządzenia
              końcowego użytkownika publicznie dostępnych usług
              telekomunikacyjnych;
            </li>
            <li>
              dane o próbach uzyskania połączenia między zakończeniami sieci, w
              tym dane o nieudanych próbach połączeń, oznaczających połączenia
              między telekomunikacyjnymi urządzeniami końcowymi lub
              zakończeniami sieci, które zostały zestawione i nie zostały
              odebrane przez użytkownika końcowego lub nastąpiło przerwanie
              zestawianych połączeń
            </li>
          </ul>

          <p>
            <strong
            ><br/>
              Dane retencyjne są przechowywane przez okres 12 miesięcy. Po tym
              okresie są usuwane.</strong
            >
          </p>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: "RODO",
  components: {},
  mounted() {
    this.$emit("loadedView");
  },
};
</script>